import { render, staticRenderFns } from "./ImpactDataStat.vue?vue&type=template&id=66ff081a&scoped=true&"
import script from "./ImpactDataStat.vue?vue&type=script&lang=js&"
export * from "./ImpactDataStat.vue?vue&type=script&lang=js&"
import style0 from "./ImpactDataStat.vue?vue&type=style&index=0&id=66ff081a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff081a",
  null
  
)

export default component.exports